import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all assets
export const getAssets = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/assets`, {
      params: {
        page: 1,
        pageSize: 25,
        sortField: 'id',
        sortOrder: 'DESC',
        ...params,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching assets:", error.response?.data || error);
    throw error;
  }
};

// GET a single asset
export const getAssetById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/assets/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching asset:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new asset
export const createAsset = async (assetData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/assets`, assetData);
    return response.data;
  } catch (error) {
    console.error("Error creating asset:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing asset
export const updateAsset = async (id, assetData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/assets/${id}`, assetData);
    return response.data;
  } catch (error) {
    console.error("Error updating asset:", error.response?.data || error);
    throw error;
  }
};

// DELETE a asset
export const deleteAsset = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/assets/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting asset:", error.response?.data || error);
    throw error;
  }
};

export const getAssetBySerial = async (serial, excludeId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/assets/by-assetSerial/${encodeURIComponent(serial)}`,
      {        params: excludeId ? { excludeId } : {},
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error checking asset serial:', error.response?.data || error);
    throw error;
  }
};

export const getAssetByAssetNumber = async (assetNumber, excludeId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/assets/by-assetNumber/${encodeURIComponent(assetNumber)}`,
      {        params: excludeId ? { excludeId } : {},
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error checking asset number:', error.response?.data || error);
    throw error;
  }
};

// GET paginated assets
export const getPaginatedAssets = async ({
  page = 1,
  pageSize = 25,
  search = '',
  groupId,
  classId,
  plantStatusId,
  PlanningTypeId,
  AssetTypeId,
  assetDepartmentId,
  assetCategoryId,
  planningGroupId,
  assetCriticalityId,
  costCenterId,
  assetDisposed,
  hireStatus,
  sortField,
  sortOrder,
}) => {
  const response = await axiosInstance.get(`${API_URL}/assets`, {    params: {
      page,
      pageSize,
      search,
      groupId,
      classId,
      plantStatusId,
      PlanningTypeId,
      AssetTypeId,
      assetDepartmentId,
      assetCategoryId,
      planningGroupId,
      assetCriticalityId,
      costCenterId,
      assetDisposed,
      hireStatus,
      sortField,
      sortOrder,
    },
    paramsSerializer: params => {
      const query = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach(v => query.append(key, v));
        } else if (value !== undefined && value !== null) {
          query.append(key, value);
        }
      }
      return query.toString();
    },
  });
  return response.data;
};

// GET paginated list of assets and areas combined
export const getPaginatedAssetsAndAreas = async ({
  page = 1,
  pageSize = 10,
  search = '',
  type = 'all',
  departmentId,
  assetId,
  areaId,
}) => {
  const response = await axiosInstance.get(`${API_URL}/assets/combined`, {
    params: {
      page,
      pageSize,
      search,
      type,
      departmentId,
      assetId,
      areaId,
    },
    paramsSerializer: params => {
      const query = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach(v => query.append(key, v));
        } else if (value !== undefined && value !== null) {
          query.append(key, value);
        }
      }
      return query.toString();
    },
  });
  return response.data;
};

export const getAssetDashboardSummary = async () => {
  const response = await axiosInstance.get(`${API_URL}/assets/dashboard-summary`);
  return response.data;
};
